{
	"filterError": "Le tableau des champs ne peut pas contenir plus de 4 éléments.",
	"perDay": "Par jour",
	"byPeriod": "Par période",
	"news": "Nouveautés"
}
